import { uplodFileStatus } from '@/constants'
import http from './request'
import axios from 'axios'
import { showToast } from 'vant'

// 上传图片
export function uploadImg(data, type = 'withdraw') {
  return http({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/user/auth/upload/image?type=${type}`,
    data
  })
}

// 上传文件
export function uploadFile(data, type = 'withdraw') {
  return http({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/user/auth/upload/file?type=${type}`,
    data
  })
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
/**
 * 上传文件（503自动重试）
 */
export async function uploadFileByS3(file, cbUrl, cbUploadProgress, type = 'youtubeOut') {
  const data = { type, fileName: file.name }
  const res = await http({
    url: '/user/auth/upload/getPreSignedUrl',
    method: 'post',
    data
  })
  const uploadUrl = res.data.path
  const accessUrl = res.data.accessUrl || uploadUrl.split('?')[0]
  if (!uploadUrl) {
    console.error('Get upload url failed', JSON.stringify(res))
    throw new Error('Get upload url failed')
  }
  if (!accessUrl) {
    showToast('Upload failed. Please try again.')
    console.error('Get access url failed', JSON.stringify(res))
    throw new Error('Get access url failed')
  }
  const MAX_RETRY = 3
  for (let retry = 0; retry <= MAX_RETRY; retry++) {
    try {
      await axios.put(uploadUrl, file, {
        headers: { 'Content-Type': file.type },
        timeout: 600 * 1000,
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          cbUploadProgress && cbUploadProgress(percent)
        }
      })
      await cbUrl(accessUrl)
      return
    } catch (err) {
      const status = err?.response?.status
      if (!uplodFileStatus.includes(status)) {
        throw err
      }
      if (retry >= MAX_RETRY) {
        throw err
      }
      console.warn(`Upload failed with 503、502、500, retry ${retry + 1}/${MAX_RETRY}...`)
      // 简单延迟：1s、2s、3s
      await sleep((retry + 1) * 1000)
    }
  }
}
